window.updateChatlioImage = function (img) {
  var isOnline = window._chatlio && window._chatlio.isOnline();
  if (img) {
    if (isOnline === true) {
      img.src = chatIconsOn;
    } else if (isOnline === false) {
      img.src = chatIconsOff;
    } else {
      img.src = chatIconsOff;
    }
    //img.setAttribute('style', 'visibility:visible');
  }
};
window.updateChatlioImages = function () {
  window.updateChatlioImage(document.querySelector('#chatlio-widget .chatlio-avatar img'));
};

window.ieVersion = function () {
  var ua = window.navigator.userAgent;
  if (ua.indexOf('Trident/7.0') > 0)
    return 11;
  else if (ua.indexOf('Trident/6.0') > 0)
    return 10;
  else if (ua.indexOf('Trident/5.0') > 0)
    return 9;
  else
    return 0;  // not IE9, 10 or 11
};

window.ieLegacy = function () {
  return [9, 10, 11].indexOf(window.ieVersion()) !== -1;
};

import '!!file-loader?name=banner1200x630.png!./assets/banner1200x630.png';
import '!!file-loader?name=robots.txt!../robots.txt';
import '!!file-loader?name=sitemap.txt!../sitemap.txt';

//import './assets/fonts.css';

import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import i18n from './multilanguage';
import VueTouch from 'vue-touch';

import {detectLocale, changeLocale} from './multilanguage/locale';

Vue.use(VueTouch, {name: 'v-touch'});

//import VueCarousel from 'vue-carousel';
//Vue.use(VueCarousel);

Vue.config.productionTip = true;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: {App}
});

//const chatIcon
import chatIconsOff from './assets/chat-icons-off.png';
import chatIconsOn from './assets/chat-icons-on.png';
import logoMascot from './assets/logo-mascot.png';



// WEBPACK FOOTER //
// ./src/main.js